import * as moment from 'moment';

export const sortByProperty = (field, reverse, primer) => {
  const key = primer
    ? function(x) {
        return primer(x[field]);
      }
    : function(x) {
        return x[field];
      };

  reverse = !reverse ? 1 : -1;

  return function(a, b) {
    return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
  };
};

export const findBySearchString = (key, searchString, itemArray) => {
  let results = [];
  itemArray.forEach(element => {
    if (element[key].toLowerCase().indexOf(searchString.toLowerCase()) !== -1) {
      results.push(element);
    }
  });
  return results;
};

export const flattenObject = (ob, isReference = false) => {
  let toReturn = {};

  if (ob && Array.isArray(ob) && isReference) {
    let refField = {};
    for (let index in ob) {
      refField = { ...refField, ...flattenObject(ob[index], isReference) };
    }
    return refField;
  }

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue;
    if (typeof ob[i] == 'object' && ob[i] !== null) {
      if (Array.isArray(ob[i]) && typeof ob[i][0] !== 'object') {
        toReturn[i] = ob[i];
      }
      let flatObject = flattenObject(ob[i], isReference);
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
};
